const env = import.meta.env;

/**
 * Configuração do app, lida das variáveis VITE_* (vão para o bundle; nada secreto aqui).
 *
 * API: se VITE_API_URL não for definida, usa o mesmo host da página na porta 3000.
 * Assim funciona sem ajuste no navegador (localhost), no emulador Android (10.0.2.2)
 * e no celular na mesma rede (IP do PC).
 */
export const config = Object.freeze({
  /** Ambiente do bundle: dev | prd (embutido pelos scripts de OTA). "local" no npm start. */
  appEnv: env.VITE_APP_ENV || 'local',
  /** Versão deste bundle web (embutida no build pelos scripts de OTA). */
  bundleVersion: env.VITE_BUNDLE_VERSION || 'dev',
  ota: Object.freeze({ manifestUrl: env.VITE_OTA_MANIFEST_URL || '' }),
  apiUrl: (env.VITE_API_URL || `${location.protocol}//${location.hostname}:3000`).replace(/\/+$/, ''),
  /** Site institucional: termos, privacidade e exclusão de conta. */
  site: Object.freeze({
    terms: 'https://ticketcar.com.br/termos/',
    privacy: 'https://ticketcar.com.br/privacidade/',
    deleteAccount: 'https://ticketcar.com.br/excluir-conta/',
  }),
});

